import type { ViewerConfig } from '../types'

export const viewer: ViewerConfig = {
  cameraPosition: [-150, 170, 350],
  minDistance: 200,
  maxDistance: 500,
  minAzimuthAngle: -Math.PI / 6,
  maxAzimuthAngle: Math.PI / 6,
  minPolarAngle: Math.PI / 2.5,
  maxPolarAngle: (85 * Math.PI) / 180,
  target: [20, 100, 0],
  getShadowManXPosition: (width: number) => -width / 2 - 50,
}
